<script>
import Footer from '@/components/global/FeatureComponents/Footer/webNew.vue'
import { getAllSchools } from 'common/utils.js';

/**
 * MY Career 页面自定义 Footer
 *
 * 复用原有 Footer/webNew.vue 的全部模板和逻辑，
 * 通过覆盖 data 中的字段来注入自定义数据。
 */

// 自定义 About Us 链接数据
const CAREER_ABOUT_US = {
  title: 'About Us',
  links: [
    { name: 'About TAL', url: 'https://en.100tal.com', target: '_blank' },
  ],
}

const CAREER_CONTAVT_EMAIL = 'thinkhub@tal.com'

const CAREER_FOLLOWS = {
  title: 'Follow Think Academy',
  links: [
    {
      icon: 'icon-facebook2',
      name: 'Facebook',
      link: 'https://www.facebook.com/thinkacademycareer',
      target: '_blank',
      linkType: 'link',
    },
    {
      icon: 'icon-instagram',
      name: 'Instagram',
      link: 'https://www.instagram.com/thinkacademy.career/',
      target: '_blank',
      linkType: 'link',
    },
    {
      icon: 'icon-linkedIn',
      name: 'LinkedIn',
      link: 'https://www.linkedin.com/company/think-academy-international-education-hub/',
      target: '_blank',
      linkType: 'link',
    },
    {
      icon: 'icon-whatsapp',
      name: 'WhatsApp',
      link: 'https://wa.me/60126880646',
      target: '_blank',
      linkType: 'link',
    },
  ],
}

export default {
  name: 'MyCareerFooter',
  extends: Footer,
  data() {
    return {
      // 覆盖 About Us 区块数据
      aboutUs: CAREER_ABOUT_US,
      // 覆盖contactEmail
      contactEmail: CAREER_CONTAVT_EMAIL,
      // 覆盖follows
      follows: CAREER_FOLLOWS,
      otherSchools: getAllSchools('my'),
    }
  },
  mounted() {
    // 客户端 mounted 后重新获取 otherSchools，确保 .net 域名下使用正确的 netUrl
    this.otherSchools = getAllSchools('my');
    // 改变 key 强制 Vue 重新创建 DOM 元素，解决 SSR hydration 后属性未更新的问题
    this.schoolsRenderKey++;
  },
}
</script>
